import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nameFirst: "",
  nameLast: "",
  email: "",
  mobile: "",
  address: {
    street: "",
    additional: "",
    city: "",
    zipcode: "",
    country: "",
  },
  wantHardware: false,

  // landlord: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setPersonalDetails: (state, { payload }) => {
      const { nameFirst, nameLast, email, mobile } = payload;

      state.nameFirst = nameFirst;
      state.nameLast = nameLast;
      state.email = email;
      state.mobile = mobile;
    },
    setLocationDetails: (state, { payload }) => {
      const { street, additional, city, zipcode, country } = payload;
      state.address = {
        street,
        additional,
        city,
        zipcode,
        country,
      };
    },
    setRFIDOrder: (state, { payload }) => {
      const { terms, widerruf, contract, wantHardware } = payload;
      console.log(wantHardware);
      state.wantHardware = wantHardware;
    },

    // setLandlord: (state, { payload }) => {
    //   const { landlord } = payload;
    //   state.landlord = landlord;
    // },
  },
});

export const getUser = (state) => state.user;
export const getCustomerId = (state) => state.user.customer_id;
export const { setPersonalDetails, setLocationDetails, setRFIDOrder } =
  userSlice.actions;

export default userSlice.reducer;
